import { Fragment, memo } from "react";

import { cn } from "@/lib/utils";
import { getRichTextSegments } from "@/feature/ai-planner/lib/chat-message.utils";

type HighlightedTextProps = {
  text: string;
  phrases?: readonly string[];
  className?: string;
  highlightClassName?: string;
};

export const HighlightedText = memo(function HighlightedText({
  text,
  phrases,
  className,
  highlightClassName,
}: HighlightedTextProps) {
  const segments = getRichTextSegments(text, phrases);

  return (
    <span
      className={cn(
        "block whitespace-pre-wrap break-words [overflow-wrap:anywhere]",
        className,
      )}
    >
      {segments.map((segment, index) =>
        segment.href ? (
          <a
            key={`${segment.text}-${index}`}
            href={segment.href}
            target="_blank"
            rel="noreferrer noopener"
            className={cn(
              "max-w-full break-all text-sky-700 underline decoration-sky-400/60 underline-offset-2 [overflow-wrap:anywhere] hover:text-sky-800 hover:decoration-sky-600 dark:text-sky-300 dark:decoration-sky-300/50 dark:hover:text-sky-200",
              segment.highlighted && "font-semibold",
              highlightClassName,
            )}
          >
            {segment.text}
          </a>
        ) : segment.highlighted ? (
          <strong
            key={`${segment.text}-${index}`}
            className={cn("font-semibold text-foreground", highlightClassName)}
          >
            {segment.text}
          </strong>
        ) : (
          <Fragment key={`${segment.text}-${index}`}>{segment.text}</Fragment>
        ),
      )}
    </span>
  );
});
